import CreateAttributeList, {
  componentAttributeTypes,
} from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, {
  getNodeComponentAttributeValue,
  setNodeComponentAttributeValue,
} from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import {
  GetLocationHoverAtt,
  GetNodeDomAttributes,
} from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import {
  BusienssControlNames,
  GenericBusinessControl,
} from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

export default class BusinessMap extends WBComponent {
  constructor() {
    super();
    this.vagaroLink = "https://www.vagaro.com/merchants/settings/business/profile"
    this.typename = wBComponentTypeNames.businessMap;
    this.displayName = "Map";
    this.dropList = defaultDropList;
    this.editList = [
      "mapLayout",
      "mapRadius",
      "mapText",
      componentAttributeTypes.multiLocation,
      ...CreateAttributeList(true, true, true, true, false, false, false).filter((e)=>e!="color"),
    ];
    this.primaryEditAttributes = [

      componentAttributeTypes.multiLocation,
      "mapLayout",
      "mapRadius",
  
    ];
    this.resizeType = ResizeableType.All;
    this.colorFields = ["mapText","backgroundColor"];
    this.icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 576 512"
        fill="currentColor"
      >
        <path d="M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z" />
      </svg>
    );

    this.cssDefinitions = [
      new NodeCSSClassDefinition(".business-map", [
        { key: "mapRadius", cssProperty: "border-radius", default: "0px" },
      ]),
      new NodeCSSClassDefinition(".map-label", [
        {
          key: "mapText",
          cssProperty: "color",
          default: "",
          stencil: "transparent",
        },
      ]),
    ];
  }

  onFirstTimeCreation(
    newParent: LayoutNode,
    thisLayout: LayoutNode,
    manager: WebDesigner
  ): void {
    setNodeComponentAttributeValue(
      thisLayout,
      componentAttributeTypes.multiLocation,
      manager.props.siteData.userContext.businessId
    );
  }

  getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
    return [
      new AttributeDefinition(
        "mapRadius",
        "Map Radius",
        "",
        AttributeInputType.FourwayMeasurmentField,
        [
          { label: "Auto", value: "" },
          { label: "S", value: "4px" },
          { label: "M", value: "12px" },
          { label: "L", value: "48px" },
        ],
        { min: 0, max: 500, step: 1, unit: "px" }
      ),
      new AttributeDefinition(
        "mapLayout",
        "Layout",
        "",
        AttributeInputType.SelectField,
        [
          { label: "Default", value: "" },
          { label: "Address Only", value: "2" },
        
        
        ],
        { min: 0, max: 500, step: 1, unit: "px" }
      ),

      new AttributeDefinition(
        "mapText",
        "Map Text",
        "",
        AttributeInputType.ColorField
      ),
    ];
  }

  RenderLayout({
    component,
    screenSize,
    userContext: siteData,
    isEditor,
  }: WBRenderProps) {

    const layout = getNodeComponentAttributeValue(
      component,
      "mapLayout",
      "1"
    );

    let cls = (layout==="2")?"":"v-map";
    const atts = GetNodeDomAttributes(
      cls+" max-100 vb-control relative",
      component,
      screenSize,
      isEditor
    );

    const bid = getNodeComponentAttributeValue(
      component,
      componentAttributeTypes.multiLocation,
      siteData.businessId
    );

    if (!isEditor) {
      return (
        <BusinessPlaceHolder
          node={component}
          dataKey={BusienssControlNames.businessMap}
          layout={layout}
          classNames={atts.className}
        />
      );
    }

    return (
      <div {...atts} {...GetLocationHoverAtt(component, siteData)}>
        <style>{super.GetComponentGlobalCSS(component, isEditor)}</style>
        <GenericBusinessControl
          key={component.id + bid}
          layout={layout}
          dataKey={BusienssControlNames.businessMap}
          node={component}
          bLocationId={bid}
          userContext={siteData}
        />
      </div>
    );
  }
}
